// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import system_config from '../src/util/system'
//引入全局样式
import './assets/css/bootstrap.css'
import './assets/fonts/iconfont.css'
import './assets/css/style.css'

//引入JQUERY
import $ from 'jquery'
import 'bootstrap/dist/js/bootstrap.min'
//引入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

import VueAMap from 'vue-amap'

Vue.use(VueAMap)

VueAMap.initAMapApiLoader({
  // 高德key
  key: 'ff506affb6a6a393d0ef2a8093925f1f',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.Walking', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
  v: '1.4.4',
  uiVersion: '1.0'
})

//图片插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})

import 'quill/dist/quill.snow.css' // for snow theme

import axios from 'axios'
//全局分页变量
Vue.prototype.$global_limit = 10
Vue.prototype.$global_page = 1

// axios.defaults.baseURL = 'http://amr_website.test/api/'
axios.defaults.baseURL = 'http://www.ahamr.cn/api/'
Vue.prototype.$http = axios
Vue.config.productionTip = false

//获取系统配置的方法
Vue.prototype.utils = system_config

//seo
import VueWechatTitle from 'vue-wechat-title'

Vue.use(VueWechatTitle)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js